const Amenagement = () => {

    return (
        <div>
            <div class="border-outline-eni d-block w-100 openSans pt-3">
                <div class="d-flex justify-content-center align-items-center">
                    <p className="text-center">
                        Si vous êtes en situation de handicap et que vous vous posez des questions sur <strong>les aménagements adaptés selon vos besoins</strong>,<br/>
                        nous vous invitons à contacter nos référents handicap par e-mail : <strong>referenthandicap@eni-ecole.fr</strong>.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Amenagement;
